import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { useMemo, useState } from 'react';
import { IUpcomingPourEventResponse } from 'types';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { themeColors, themeShadows } from 'app/shared/theme/theme';
import { formatTimeWithDateIfNotToday } from 'app/shared/utils/formatTimeWithDate';
import { Grid, GridVariant } from 'app/shared/components/generic-ui';

interface IUpcomingBatchItemProps {
  schedule: IUpcomingPourEventResponse['scheduleModels'][number];
}

export const UpcomingBatchItem = ({ schedule }: IUpcomingBatchItemProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const data = useMemo(() => {
    return [
      {
        label: 'Printed',
        value: formatTimeWithDateIfNotToday(schedule.printed),
      },
      {
        label: 'Loading Started',
        value: formatTimeWithDateIfNotToday(schedule.loadingStarted),
      },
      {
        label: 'To Job',
        value: formatTimeWithDateIfNotToday(schedule.toJob),
      },
      {
        label: 'Arrive Job',
        value: formatTimeWithDateIfNotToday(schedule.arriveJob),
      },
      {
        label: 'Unloading Started',
        value: formatTimeWithDateIfNotToday(schedule.unloading),
      },
      {
        label: 'End Unloading',
        value: formatTimeWithDateIfNotToday(schedule.endUnloading),
      },
      {
        label: 'Leave Job',
        value: formatTimeWithDateIfNotToday(schedule.leaveJob),
      },
      {
        label: 'In Yard',
        value: formatTimeWithDateIfNotToday(schedule.inYard),
      },
    ];
  }, [schedule]);
  return (
    <div>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white',
          marginBottom: 8,
          boxShadow: themeShadows.shadowSmall,
          padding: 12,
          cursor: 'pointer',
        }}
      >
        <CustomTypography
          variant="bodySmall"
          color="accentDark"
          bold
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}
        >
          {`Load #${schedule.loadNumber}`}
          <CustomTypography variant="buttonTextSmall" color="accentDark">
            {formatTimeWithDateIfNotToday(schedule.arriveJob)}
          </CustomTypography>
        </CustomTypography>
        <div
          style={{
            width: 24,

            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            height: 22,
          }}
        >
          {isExpanded ? (
            <ExpandLessIcon
              style={{
                width: 22,
                marginRight: '-8px',
                color: themeColors.mbsBlue,
              }}
            />
          ) : (
            <ExpandMoreIcon
              style={{
                width: 22,
                marginRight: '-8px',
                color: themeColors.mbsBlue,
              }}
            />
          )}
        </div>
      </div>
      {isExpanded && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: 'white',
            marginBottom: 8,
            boxShadow: themeShadows.shadowSmall,
            padding: 12,
          }}
        >
          <Grid container spacing={1}>
            {data.map(el => (
              <div
                key={el.label}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  padding: 4,
                }}
              >
                <Grid item variant={GridVariant.MEDIUM}>
                  <CustomTypography variant="caption2" bold color="greyscale2">
                    {el.label}
                  </CustomTypography>
                </Grid>
                <Grid
                  item
                  variant={GridVariant.MEDIUM}
                  style={{
                    display: 'flex',
                    wordWrap: 'break-word',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <CustomTypography variant="bodySmall" color="accentDark">
                    {el.value}
                  </CustomTypography>
                </Grid>
              </div>
            ))}
          </Grid>
        </div>
      )}
    </div>
  );
};
